import {i18n} from '@/plugins/i18n'

export const transactionStatus = {
    INIT: "INIT",
    FAILED: "FAILED",
    SUCCEED: "SUCCEED",
    CANCELED: "CANCELED",
    SETTLEMENT_PENDING: "SETTLEMENT_PENDING",
    SETTLEMENT_REJECTED: "SETTLEMENT_REJECTED",
    VERIFY_PENDING: "VERIFY_PENDING",
    UNVERIFIED: "UNVERIFIED",
    SWITCHED: "SWITCHED",
    EXPIRED: "EXPIRED",
};

export const statusStr = {
    INIT: i18n.t('transaction.status.init'),
    FAILED: i18n.t('transaction.status.failed'),
    SUCCEED: i18n.t('transaction.status.succeed'),
    CANCELED: i18n.t('transaction.status.canceled'),
    REVERSED: i18n.t('transaction.status.reversed'),
    SETTLEMENT_PENDING: i18n.t('transaction.status.settlement_pending'),
    SETTLEMENT_REJECTED: i18n.t('transaction.status.settlement_rejected'),
    VERIFY_PENDING: i18n.t('transaction.status.verify_pending'),
    UNVERIFIED: i18n.t('transaction.status.unverified'),
    SWITCHED: i18n.t('transaction.status.switched'),
    EXPIRED: i18n.t('transaction.status.expired'),

    get(status) {
        let status_str = null;

        Object.keys(transactionStatus).forEach(item => {
            if (transactionStatus[item] === status) {
                status_str = statusStr[item]
            }
        });

        return status_str
    }
};

export const statusVariant = (status) => {
    if (status === transactionStatus.SUCCEED) {
        return 'success'
    }

    if (status === transactionStatus.INIT || status === transactionStatus.EXPIRED) {
        return 'secondary'
    }

    if (status === transactionStatus.VERIFY_PENDING) {
        return 'primary'
    }

    if (status === transactionStatus.FAILED || status === transactionStatus.UNVERIFIED) {
        return 'danger'
    }

    if (status === transactionStatus.CANCELED) {
        return 'warning'
    }

    if (status === transactionStatus.SETTLEMENT_PENDING) {
        return 'secondary'
    }

    if (status === transactionStatus.SETTLEMENT_REJECTED) {
        return 'danger'
    }

    return 'dark'
};